// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"SearchTool_toolbar__WJH27","active":"SearchTool_active__CWqcl","padding12px":"SearchTool_padding12px__2R9ua","textInput":"SearchTool_textInput__1X2cY"};